import axios from "axios";
const FORMAT_ACCEPT_MAP = {
    csv: "text/csv;charset=utf-8;",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};
function saveFile(data, fileNameSuffix, format) {
    const fileName = `export_${fileNameSuffix}.${format}`;
    const blob = new Blob([data], {
        type: FORMAT_ACCEPT_MAP[format]
    });
    if (window.navigator.msSaveBlob) {
        // FOR IE BROWSER
        navigator.msSaveBlob?.(blob, fileName);
    }
    else {
        // FOR OTHER BROWSERS
        const csvUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", csvUrl);
        link.setAttribute("download", fileName);
        link.click();
    }
}
export async function exportDevices(format, technology, projectId, deviceIds) {
    try {
        const { data } = await axios.post(`${process.env.VUE_APP_API}/${technology}/devices/export`, deviceIds, {
            headers: {
                Accept: FORMAT_ACCEPT_MAP[format]
            },
            responseType: "arraybuffer"
        });
        saveFile(data, `${projectId}_${technology}`, format);
    }
    catch (e) {
        console.error(e);
        return e.data?.errors;
    }
}
